
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "viewer": "viewer-b8614645",
    "fit": "fit-b8614645",
    "view": "view-b8614645",
    "visible": "visible-b8614645"
};
exports.styleSource = ".viewer-b8614645{position:relative}.viewer-b8614645.fit-b8614645{width:100%;height:100%}.viewer-b8614645.fit-b8614645>.view-b8614645{height:100%}.viewer-b8614645>.view-b8614645{position:absolute;top:0;width:100%}.viewer-b8614645>.view-b8614645.visible-b8614645{position:relative}.view-b8614645{visibility:hidden;opacity:0;transition:all .2s ease}.view-b8614645.visible-b8614645{visibility:inherit;opacity:1}";
exports.default = exports.styles;
            
module.moduleType = "style";
